import { tables } from '../../../config'
import moment from 'moment'
import { formatDay, formatyear, convertLableExcel, getDateOfWeek, getColByDay } from '../../../utils/date'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import modeQuery from '@/constants/modeQuery'
import { mapDataTable } from '../../../utils/sellReport'
import i18n from '@/i18n'
import * as _ from 'lodash'
import reportType from '@/config/reportType'
import { platform } from '@/constants/storePlatform'

export default {
  SET_LIST_REPORT (state, payload) {
    const currencyRate = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
    const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    const currentCurrencySymbol = (currencyRate?.toCurrency || storeConfig?.currency || '') !== '' ? ` (${currencyRate?.toCurrency || storeConfig?.currency})` : ''
    state.loading = true
    const list = {
      title: {},
      items: {}
    }
    const cols = {}
    let fields = { Name: 'name' }
    let totals = { name: 'Totals' }
    let data = []
    if (payload.type === 'products') {
      const sellReport = mapDataTable(payload.report)
      state.sellReportData.items = [...sellReport]
      let paymentsCount = 0
      
      payload.report.forEach((elem, index) => {
        if (elem.paymentDetails && elem.paymentDetails.length > paymentsCount) {
          paymentsCount = elem.paymentDetails.length
        }
      })

      state.sellReportData.paymentsCount = new Array(paymentsCount)
      state.json_data_sell_report = [...sellReport].map(report => {
        const element = { ...report }
        for (let index = 0; index < state.sellReportData.paymentsCount.length; index++) {
          element[`amount_${index + 1}`] = (Number(element[`amount_${index + 1}`] || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        }
        element.totalPrice = (Number(element.totalPrice || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        element.tax = (Number(element.tax || 0) * Number(currencyRate?.rate || 1))
        element.totalRevenue = (Number(element.totalRevenue || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        element.totalTax = (Number(element.totalTax || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        element.netRevenue = (Number(element.netRevenue || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        element.avgOrderValue = (Number(element.avgOrderValue || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        return element
      })
    }
    if (payload.type === 'outlet-revenue') {
      const startDate = moment(state.query.createdAtMin).toArray().slice(0, 3)
      const endDate = moment(state.query.createdAtMax).toArray().slice(0, 3)
      if (payload.fillter_type === modeQuery.DATE) {
        const range = moment(endDate).diff(moment(startDate), 'days')
        const days = getColByDay(state.query.createdAtMin, range)
        Object.keys(days).forEach(key => {
          list.items[formatDay(key) || ''] = Object.assign({}, list.items[formatDay(key) || ''] || {})
        })
        
        const sortedData = payload.report.sort((a, b) => new Date(a[tables[payload.type]]) - new Date(b[tables[payload.type]])).filter(item => item.outletName)
        sortedData.forEach(item => {
          list.items[formatDay(item[tables[payload.type]]) || ''] = Object.assign({}, list.items[formatDay(item[tables[payload.type]]) || ''] || {})
          list.items[formatDay(item[tables[payload.type]]) || ''][item.outletName] = parseFloat(item.totalPrice || item.totalRevenue || '0')
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[item.outletName] = true
        })
      }
      if (payload.fillter_type === modeQuery.MONTH) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.month) - parseInt(b.month)).filter(item => item.outletName)
        sortedData.forEach(item => {
          list.items[item.month + '/' + item.year || ''] = Object.assign({}, list.items[item.month + '/' + item.year || ''] || {})
          list.items[item.month + '/' + item.year || ''][item.outletName] = parseFloat(item.totalPrice || item.totalRevenue || '0')
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[item.outletName] = true
        })
      }
      if (payload.fillter_type === modeQuery.YEAR) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year)).filter(item => item.outletName)
        sortedData.forEach(item => {
          list.items[item.year || ''] = Object.assign({}, list.items[item.year || ''] || {})
          list.items[item.year || ''][item.outletName] = parseFloat(item.totalPrice || item.totalRevenue || '0')
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[item.outletName] = true
        })
      }
      if (payload.fillter_type === modeQuery.WEEK) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.week) - parseInt(b.week)).filter(item => item.outletName)
        sortedData.forEach(item => {
          list.items['Week ' + item.week || ''] = Object.assign({}, list.items['Week ' + item.week || ''] || {})
          list.items['Week ' + item.week || ''][item.outletName] = parseFloat(item.totalPrice || item.totalRevenue || '0')
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[item.outletName] = true
        })
      }
    } else if (payload.type === 'categories') {
      payload.report.forEach(item => {
        list.items[item[tables[payload.type]] || 'Uncategorized'] = Object.assign({}, list.items[item[tables[payload.type]] || 'Uncategorized'] || {})
        list.items[item[tables[payload.type]] || 'Uncategorized'].revenue = parseFloat(item.totalPrice)
        list.title[item[tables[payload.type]] || 'Uncategorized'] = item[tables[payload.type]]
        cols.revenue = true
      })
    } else if (payload.type === 'payment-methods') {
      const startDate = moment(state.query.createdAtMin).toArray().slice(0, 3)
      const endDate = moment(state.query.createdAtMax).toArray().slice(0, 3)
      if (payload.fillter_type === modeQuery.DATE) {
        const range = moment(endDate).diff(moment(startDate), 'days')
        const days = getColByDay(state.query.createdAtMin, range)
        Object.keys(days).forEach(key => {
          list.items[formatDay(key) || ''] = Object.assign({}, list.items[formatDay(key) || ''] || {})
        })
        
        const sortedData = payload.report.sort((a, b) => new Date(a[tables[payload.type]]) - new Date(b[tables[payload.type]]))
        sortedData.forEach(item => {
          list.items[formatDay(item[tables[payload.type]]) || ''] = Object.assign({}, list.items[formatDay(item[tables[payload.type]]) || ''] || {})
          list.items[formatDay(item[tables[payload.type]]) || ''][_.startCase((item.paymentName || '').split(/-|_/).join(' '))] = parseFloat(item.totalSale) - parseFloat(item.totalRefund)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[_.startCase((item.paymentName || '').split(/-|_/).join(' '))] = true
        })
      }
      if (payload.fillter_type === modeQuery.MONTH) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.month) - parseInt(b.month))
        sortedData.forEach(item => {
          list.items[item.month + '/' + item.year || ''] = Object.assign({}, list.items[item.month + '/' + item.year || ''] || {})
          list.items[item.month + '/' + item.year || ''][_.startCase((item.paymentName || '').split(/-|_/).join(' '))] = parseFloat(item.totalSale) - parseFloat(item.totalRefund)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[_.startCase((item.paymentName || '').split(/-|_/).join(' '))] = true
        })
      }
      if (payload.fillter_type === modeQuery.YEAR) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year))
        sortedData.forEach(item => {
          list.items[item.year || ''] = Object.assign({}, list.items[item.year || ''] || {})
          list.items[item.year || ''][_.startCase(item.paymentName.split(/-|_/).join(' '))] = parseFloat(item.totalSale) - parseFloat(item.totalRefund)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[_.startCase(item.paymentName.split(/-|_/).join(' '))] = true
        })
      }
      if (payload.fillter_type === modeQuery.WEEK) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.week) - parseInt(b.week))
        sortedData.forEach(item => {
          list.items['Week ' + item.week || ''] = Object.assign({}, list.items['Week ' + item.week || ''] || {})
          list.items['Week ' + item.week || ''][_.startCase(item.paymentName.split(/-|_/).join(' '))] = parseFloat(item.totalSale) - parseFloat(item.totalRefund)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
          cols[_.startCase(item.paymentName.split(/-|_/).join(' '))] = true
        })
      }
    } else if (payload.type === 'sale-summary' || payload.type === 'fulfillment-summary') {
      const startDate = moment(state.query.createdAtMin).toArray().slice(0, 3)
      const endDate = moment(state.query.createdAtMax).toArray().slice(0, 3)
      if (payload.fillter_type === modeQuery.DATE) {
        const range = moment(endDate).diff(moment(startDate), 'days')
        const days = getColByDay(state.query.createdAtMin, range)
        Object.keys(days).forEach(key => {
          list.items[formatDay(key) || ''] = Object.assign({}, list.items[formatDay(key) || ''] || {})
        })
        
        const sortedData = payload.report.sort((a, b) => new Date(a[tables[payload.type]]) - new Date(b[tables[payload.type]]))
        sortedData.forEach(item => {
          list.items[formatDay(item[tables[payload.type]]) || ''] = Object.assign({}, list.items[formatDay(item[tables[payload.type]]) || ''] || {})
          list.items[formatDay(item[tables[payload.type]]) || ''] = Object.assign({}, item)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
        })
      }
      if (payload.fillter_type === modeQuery.MONTH) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.month) - parseInt(b.month))
        sortedData.forEach(item => {
          list.items[item.month + '/' + item.year || ''] = Object.assign({}, list.items[item.month + '/' + item.year || ''] || {})
          list.items[item.month + '/' + item.year || ''] = Object.assign({}, item)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
        })
      }
      if (payload.fillter_type === modeQuery.YEAR) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year))
        sortedData.forEach(item => {
          list.items[item.year || ''] = Object.assign({}, list.items[item.year || ''] || {})
          list.items[formatyear(item.year) || ''] = Object.assign({}, item)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
        })
      }
      if (payload.fillter_type === modeQuery.WEEK) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.week) - parseInt(b.week))
        sortedData.forEach(item => {
          list.items['Week ' + item.week || ''] = Object.assign({}, list.items['Week ' + item.week || ''] || {})
          list.items['Week ' + item.week || ''] = Object.assign({}, item)
          list.title[formatDay(item[tables[payload.type]]) || ''] = formatDay(item[tables[payload.type]])
        })
      }
    } else if (payload.type === 'cashiers' || payload.type === 'salesman') {
      const startDate = moment(state.query.createdAtMin).toArray().slice(0, 3)
      const endDate = moment(state.query.createdAtMax).toArray().slice(0, 3)
      if (payload.fillter_type === modeQuery.DATE) {
        const range = moment(endDate).diff(moment(startDate), 'days')
        const days = getColByDay(state.query.createdAtMin, range)
        Object.keys(days).forEach(key => {
          list.items[formatDay(key) || ''] = Object.assign({}, list.items[formatDay(key) || ''] || {})
        })
        
        const sortedData = payload.report.sort((a, b) => new Date(a[tables[payload.type]]) - new Date(b[tables[payload.type]]))
        sortedData.forEach(item => {
          list.items[formatDay(item.createdAt) || ''] = Object.assign({}, list.items[formatDay(item.createdAt) || ''] || {})
          list.items[formatDay(item.createdAt) || ''][item[tables[payload.type]] || ''] = item.totalPrice
          list.title[formatDay(item.createdAt) || ''] = formatDay(item.createdAt)
          cols[item[tables[payload.type]] || ''] = true
        })
      }
      if (payload.fillter_type === modeQuery.MONTH) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.month) - parseInt(b.month))
        sortedData.forEach(item => {
          list.items[item.month + '/' + item.year || ''] = Object.assign({}, list.items[item.month + '/' + item.year || ''] || {})
          list.items[item.month + '/' + item.year || ''][item[tables[payload.type]] || ''] = item.totalPrice
          list.title[formatDay(item.createdAt) || ''] = formatDay(item.createdAt)
          cols[item[tables[payload.type]] || ''] = true
        })
      }
      if (payload.fillter_type === modeQuery.YEAR) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year))
        sortedData.forEach(item => {
          list.items[item.year || ''] = Object.assign({}, list.items[item.year || ''] || {})
          list.items[formatyear(item.year) || ''][item[tables[payload.type]] || ''] = item.totalPrice
          list.title[formatDay(item.createdAt) || ''] = formatDay(item.createdAt)
          cols[item[tables[payload.type]] || ''] = true
        })
      }
      if (payload.fillter_type === modeQuery.WEEK) {
        const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.week) - parseInt(b.week))
        sortedData.forEach(item => {
          list.items['Week ' + item.week || ''] = Object.assign({}, list.items['Week ' + item.week || ''] || {})
          list.items['Week ' + item.week || ''][item[tables[payload.type]] || ''] = item.totalPrice
          list.title[formatDay(item.createdAt) || ''] = formatDay(item.createdAt)
          cols[item[tables[payload.type]] || ''] = true
        })
      }
    } else if (payload.type !== 'orders') {
      payload.report.forEach(item => {
        list.title[item[tables[payload.type]] || ''] = item[tables[payload.type]]
        if (!list.items[item[tables[payload.type]] || '']) {
          list.items[item[tables[payload.type]] || ''] = {}
        }
        if (payload.fillter_type === modeQuery.DATE) {
          list.items[item[tables[payload.type]] || ''][formatDay(item.createdAt)] = item.totalPrice || item.totalRevenue || '0'
        }
        if (payload.fillter_type === modeQuery.YEAR) {
          list.items[item[tables[payload.type]] || ''][formatyear(item.createdAt)] = item.totalPrice || item.totalRevenue || '0'
        }
        if (payload.fillter_type === modeQuery.MONTH) {
          list.items[item[tables[payload.type]] || ''][item.createdAt] = item.totalPrice || item.totalRevenue || '0'
        }
        if (payload.fillter_type === modeQuery.WEEK) {
          list.items[item[tables[payload.type]] || ''][Number(item.createdAt) + 1] = item.totalPrice || item.totalRevenue || '0'
        }
        cols[item.createdAt] = true
      })
    }
    if (payload.type !== 'orders' && payload.type !== 'payment-methods' && payload.type !== 'total-revenues' && payload.type !== 'sale-summary' && !payload.type === 'fulfillment' && payload.type !== 'cashiers' && payload.type !== 'salesman' && payload.type !== 'outlet-revenue' && payload.type !== 'categories') {
      Object.keys(list.items).forEach(item => {
        list.items[item] = {
          ...state.cols,
          ...list.items[item]
        }
      })
    }
    Object.keys(state.cols).forEach(item => {
      const name = payload.fillter_type === modeQuery.WEEK ? getDateOfWeek(state.query.createdAtMin, item) : convertLableExcel(item)
      fields = { ...fields, [name]: item }
      let total = 0
      Object.keys(list.items).forEach(items => {
        totals = { ...totals, [item]: (total += parseFloat(list.items[items][item])).toFixed(2) }
      })
    })
    for (const report in list.items) {
      data = [...data, { name: report, ...list.items[report] }]
    }
    if (payload.type === 'products') {
      fields = {
        Outlet: 'outletName',
        Cashier: 'cashier',
        'Sales person': 'salesman',
        Date: 'createdAt',
        'Order ID': 'entityID',
        'Order Name': 'incrementID',
        [i18n.t('Shift')]: 'shiftName',
        Sku: 'sku',
        'Product Name': 'name',
        [i18n.t('Category')]: 'productCategory',
        Quantity: 'quantity',
        [`Total${currentCurrencySymbol}`]: 'totalPrice',
        [`Tax${currentCurrencySymbol}`]: 'tax',
        [`Total (Tax Excluded)${currentCurrencySymbol}`]: 'subtotalPrice',
        [`Discount${currentCurrencySymbol}`]: 'totalDiscount',
        Note: 'note',
        'Payment method name 1': 'paymentName_1',
        'Payment method amount 1': 'amount_1',
        'Payment method date 1': 'processedAt_1',
        'Payment reference 1': 'ref_1',
        'Payment method note 1': 'note_1'
      }
      if (getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM) !== platform.KIDZANIA) {
        delete fields[i18n.t('Shift')]
        delete fields[i18n.t('Category')]
      }

      for (let index = 1; index < state.sellReportData.paymentsCount.length; index++) {
        fields[`Payment method name ${index + 1}`] = `paymentName_${index + 1}`
        fields[`Payment method amount ${index + 1}`] = `amount_${index + 1}`
        fields[`Payment method date ${index + 1}`] = `processedAt_${index + 1}`
        fields[`Payment reference ${index + 1}`] = `ref_${index + 1}`
        fields[`Payment method note ${index + 1}`] = `note_${index + 1}`
      }

      data = state.sellReportData.items
    } else if (payload.type === 'fulfillment') {
      fields = {
        [i18n.t('date')]: 'date',
        [`${i18n.t('total_revenue')}${currentCurrencySymbol}`]: 'totalRevenue',
        [`${i18n.t('tax')}${currentCurrencySymbol}`]: 'totalTax',
        [`${i18n.t('net_revenue')}${currentCurrencySymbol}`]: 'netRevenue',
        [`${i18n.t('avg_order_value')}${currentCurrencySymbol}`]: 'avgOrderValue',
        [i18n.t('number_of_orders')]: 'orderCount',
        [i18n.t('fulfillment')]: 'orderCount',
        [i18n.t('avg_number_of_item_per_order')]: 'avgItemCount',
        [i18n.t('new_customer')]: 'revNewCustomer',
        [`${i18n.t('returning_customer')}${currentCurrencySymbol}`]: 'revReturnCustomer'
      }
    }

    if (payload.type === 'sale-summary') {
      if (window.location.pathname === '/tax') {
        fields = {
          [i18n.t('date')]: 'date',
          [`${i18n.t('tax')}${currentCurrencySymbol}`]: 'totalTax'
        }
      }
      if (window.location.pathname === '/revenue-by-customer') {
        fields = {
          [i18n.t('date')]: 'date',
          [`${i18n.t('new_customer')}${currentCurrencySymbol}`]: 'revNewCustomer',
          [`${i18n.t('returning_customer')}${currentCurrencySymbol}`]: 'revReturnCustomer'
        }
      }
      if (window.location.pathname === '/net-revenue') {
        fields = {
          [i18n.t('date')]: 'date',
          [`${i18n.t('net_revenue')}${currentCurrencySymbol}`]: 'netRevenue'
        }
      }
      if (window.location.pathname === '/total-revenue') {
        fields = {
          [i18n.t('date')]: 'date',
          [`${i18n.t('total_revenue')}${currentCurrencySymbol}`]: 'totalRevenue'
        }
      }
      if (window.location.pathname === '/number-of-orders') {
        fields = {
          [i18n.t('date')]: 'date',
          [i18n.t('number_of_orders')]: 'orderCount'
        }
      }
      if (window.location.pathname === '/average-order-value') {
        fields = {
          [i18n.t('date')]: 'date',
          [`${i18n.t('avg_order_value')}${currentCurrencySymbol}`]: 'avgOrderValue'
        }
      }
      if (window.location.pathname === '/average-item-per-order') {
        fields = {
          [i18n.t('date')]: 'date',
          [i18n.t('avg_number_of_item_per_order')]: 'avgItemCount'
        }
      }
      if (window.location.pathname === '/refund') {
        fields = {
          [i18n.t('date')]: 'date',
          [`${i18n.t('refund')}${currentCurrencySymbol}`]: 'totalRefund'
        }
      }
      if (window.location.pathname === '/discount') {
        fields = {
          [i18n.t('date')]: 'date',
          [`${i18n.t('discount')}${currentCurrencySymbol}`]: 'totalDiscount'
        }
      }
    }

    if (payload.type === 'fulfillment-summary') {
      if (window.location.pathname === '/fulfillment') {
        fields = {
          [i18n.t('date')]: 'date',
          [i18n.t('fulfillment')]: 'orderCount'
        }
      }
    }

    let totalPrice = 0
    let totalTax = 0
    let totalTaxProduct = 0
    let totalPaymentAmoun1 = 0
    let totalPaymentAmoun2 = 0
    let totalPaymentAmoun3 = 0
    let totalPaymentAmoun4 = 0
    let totalPaymentAmoun5 = 0
    let totalPaymentAmoun6 = 0
    let totalPaymentAmoun7 = 0
    let totalPaymentAmoun8 = 0
    let totalPaymentAmoun9 = 0
    let totalSubtotalPrice = 0
    let totalDiscountColumn = 0
    if ((payload.query.page === 1 && payload.type === 'sale-summary') || payload.type !== 'sale-summary') {
      state.json_fields = fields
    }
    state.json_data = [...data, totals].map(report => {
      const element = { ...report }
      let rate = currencyRate?.rate || 1
      if (payload.type === 'products') {
        if (element.presentmentCurrency && element.currencyExchangeRate && element.presentmentCurrency === currencyRate?.toCurrency) {
          rate = element.currencyExchangeRate
        }
        for (let index = 0; index < state.sellReportData.paymentsCount.length; index++) {
          element[`amount_${index + 1}${currentCurrencySymbol}`] = (Number(element[`amount_${index + 1}`] || 0) * Number(rate))
          if (element[`processedAt_${index + 1}`]) {
            element[`processedAt_${index + 1}`] = moment(element[`processedAt_${index + 1}`]).format('DD/MM/YYYY HH:mm')
          }
        }
        if (element.createdAt) {
          element.createdAt = moment(element.createdAt).format('DD/MM/YYYY HH:mm')
        }
        element.totalPrice = (Number(element.totalPrice || 0) * Number(rate))
        element.tax = (Number(element.tax || 0) * Number(rate))
        element.totalRevenue = (Number(element.totalRevenue || 0) * Number(rate))
        element.totalTax = (Number(element.totalTax || 0) * Number(rate))
        element.subtotalPrice = (Number(element.subtotalPrice || 0) * Number(rate))
        element.totalDiscount = (Number(element.totalDiscount || 0) * Number(rate))
        element.netRevenue = (Number(element.netRevenue || 0) * Number(rate))
        element.avgOrderValue = (Number(element.avgOrderValue || 0) * Number(rate))
        element.amount_1 = (Number(element.amount_1 || 0) * Number(rate))
        element.amount_2 = (Number(element.amount_2 || 0) * Number(rate))
        element.amount_3 = (Number(element.amount_3 || 0) * Number(rate))
        element.amount_4 = (Number(element.amount_4 || 0) * Number(rate))
        element.amount_5 = (Number(element.amount_5 || 0) * Number(rate))
        element.amount_6 = (Number(element.amount_6 || 0) * Number(rate))
        element.amount_7 = (Number(element.amount_7 || 0) * Number(rate))
        element.amount_8 = (Number(element.amount_8 || 0) * Number(rate))
        element.amount_9 = (Number(element.amount_9 || 0) * Number(rate))
      } else {
        element.totalPrice = (Number(element.totalPrice || 0) * Number(rate)).toFixed(2)
        element.tax = (Number(element.tax || 0) * Number(rate)).toFixed(2)
        element.totalRevenue = (Number(element.totalRevenue || 0) * Number(rate)).toFixed(2)
        element.totalTax = (Number(element.totalTax || 0) * Number(rate)).toFixed(2)
        element.subtotalPrice = (Number(element.subtotalPrice || 0) * Number(rate)).toFixed(2)
        element.totalDiscount = (Number(element.totalDiscount || 0) * Number(rate)).toFixed(2)
        element.netRevenue = (Number(element.netRevenue || 0) * Number(rate)).toFixed(2)
        element.avgOrderValue = (Number(element.avgOrderValue || 0) * Number(rate)).toFixed(2)
      }
      element.orderCount = element.orderCount || 0
      totalPrice += Number(element.totalPrice || 0)
      totalTax += Number(element.totalTax)
      totalTaxProduct += Number(element.tax)
      totalSubtotalPrice += Number(element.subtotalPrice)
      totalDiscountColumn += Number(element.totalDiscount)
      totalPaymentAmoun1 += Number(element.amount_1)
      totalPaymentAmoun2 += Number(element.amount_2)
      totalPaymentAmoun3 += Number(element.amount_3)
      totalPaymentAmoun4 += Number(element.amount_4 || 0)
      totalPaymentAmoun5 += Number(element.amount_5 || 0)
      totalPaymentAmoun6 += Number(element.amount_6 || 0)
      totalPaymentAmoun7 += Number(element.amount_7 || 0)
      totalPaymentAmoun8 += Number(element.amount_8 || 0)
      totalPaymentAmoun9 += Number(element.amount_9 || 0)
      if (payload.type === 'products' && element.name === 'Totals') {
        element.tax = parseFloat(totalTaxProduct.toFixed(10))
        element.totalPrice = parseFloat(totalPrice.toFixed(10))
        element.totalTax = parseFloat(totalTax.toFixed(10))
        element.subtotalPrice = parseFloat(totalSubtotalPrice.toFixed(10))
        element.totalDiscount = parseFloat(totalDiscountColumn.toFixed(10))
        element.amount_1 = parseFloat(totalPaymentAmoun1.toFixed(10))
        element.amount_2 = parseFloat(totalPaymentAmoun2.toFixed(10))
        element.amount_3 = parseFloat(totalPaymentAmoun3.toFixed(10))
        element.amount_4 = parseFloat(totalPaymentAmoun4.toFixed(10))
        element.amount_5 = parseFloat(totalPaymentAmoun5.toFixed(10))
        element.amount_6 = parseFloat(totalPaymentAmoun6.toFixed(10))
        element.amount_7 = parseFloat(totalPaymentAmoun7.toFixed(10))
        element.amount_8 = parseFloat(totalPaymentAmoun8.toFixed(10))
        element.amount_9 = parseFloat(totalPaymentAmoun9.toFixed(10))
      } else if (element.name === 'Totals') {
        element.totalPrice = totalPrice.toFixed(2)
        element.totalTax = totalTax.toFixed(2)
        element.subtotalPrice = totalSubtotalPrice.toFixed(2)
        element.totalDiscount = totalDiscountColumn.toFixed(2)
        element.amount_1 = totalPaymentAmoun1.toFixed(2)
        element.amount_2 = totalPaymentAmoun2.toFixed(2)
        element.amount_3 = totalPaymentAmoun3.toFixed(2)
        element.amount_4 = totalPaymentAmoun4.toFixed(2)
        element.amount_5 = totalPaymentAmoun5.toFixed(2)
        element.amount_6 = totalPaymentAmoun6.toFixed(2)
        element.amount_7 = totalPaymentAmoun7.toFixed(2)
        element.amount_8 = totalPaymentAmoun8.toFixed(2)
        element.amount_9 = totalPaymentAmoun9.toFixed(2)
      }
      return element
    })
    if (payload.type === 'product-sold' || payload.type === 'product-sold-categories') {
      state.productReportData = { items: payload.report }

      const dataResolved = Object.keys(state.productReportData.items).map(item => {
        var additionalDataKey = 'additionalData'
        var nameKey = 'items_name'
        let additionalDataValue = ''
        if (state.productReportData.items[item][additionalDataKey] && state.productReportData.items[item][additionalDataKey][nameKey]) {
          additionalDataValue = state.productReportData.items[item][additionalDataKey][nameKey]
        }
        return { ...state.productReportData.items[item], date: item, additionalData: additionalDataValue }
      })
      const dataFields = {
        [i18n.t('Name')]: 'name',
        [i18n.t('sku')]: 'sku',
        [i18n.t('variants')]: 'additionalData',
        [i18n.t('total_quantity_sold')]: 'totalQtySold',
        [i18n.t('quantity_refund')]: 'totalQtyRefund',
        [i18n.t('net_quantity_sold')]: 'netQtySold'
      }
      if (payload.type !== 'products') {
        state.json_data = dataResolved
        state.json_fields = dataFields
      }
    } else if (payload.type === 'product-profit') {
      state.productReportData = { items: payload.report }
      const fields = {
        [i18n.t('sku')]: 'sku',
        [i18n.t('product_title')]: 'name',
        [i18n.t('variants')]: 'additionalData',
        [`${i18n.t('total_price')}${currentCurrencySymbol}`]: 'totalPrice',
        [`${i18n.t('cost')}${currentCurrencySymbol}`]: 'cost',
        [`${i18n.t('gross_profit')}${currentCurrencySymbol}`]: 'grossProfit',
        [i18n.t('margin')]: 'margin'
      }
      const json_data = []
      payload.report.forEach(element => {
        var additionalDataKey = 'additionalData'
        var nameKey = 'items_name'
        let additionalDataValue = ''
        if (element[additionalDataKey] && element[additionalDataKey][nameKey]) {
          additionalDataValue = element[additionalDataKey][nameKey]
        }
        json_data.push({
          ...element,
          totalPrice: (Number(element.totalPrice || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
          cost: (Number(element.cost || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
          grossProfit: (Number(element.grossProfit || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
          additionalData: additionalDataValue
        })
      })
      state.json_data = json_data
      state.json_fields = fields
    } else if (payload.type === 'payment-methods' || payload.type === 'outlet-revenue' || payload.type === 'categories') {
      state.paymentReportData = list
      const paymentFields = {}
      Object.keys(cols).sort().forEach(col => {
        paymentFields[col] = col
        state.json_data.forEach((item, index) => {
          if (!item[col]) {
            state.json_data[index][col] = 0
          }
          state.json_data[index][col] = (Number(state.json_data[index][col] || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        })
      })
      state.json_fields = {
        [i18n.t('Date')]: 'name',
        ...paymentFields
      }
      totals = { name: 'Totals' }
      Object.keys(state.json_fields).forEach(item => {
        let total = 0
        state.json_data.forEach(itemData => {
          totals = { ...totals, [item]: (total += (Number(itemData[item] || 0))).toFixed(2) }
        })
        if (item !== 'Date') {
          state.json_fields[`${item}${currentCurrencySymbol}`] = state.json_fields[item]
          delete state.json_fields[item]
        }
      })
      state.json_data = state.json_data.filter(data => data.name !== 'Totals')
      state.json_data = [...state.json_data, totals]
    } else if (payload.type !== 'orders') {
      state.reportData = payload.type === 'product-sold' || payload.type === 'product-sold-categories' ? { items: payload.report } : list
      const dataResolved = Object.keys(state.reportData.items).map(item => {
        if (payload.type === 'sale-summary' || payload.type === 'fulfillment-summary') {
          return {
            ...state.reportData.items[item],
            date: item,
            totalTax: (Number(state.reportData.items[item].totalTax || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            netRevenue: (Number(state.reportData.items[item].netRevenue || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            totalRevenue: (Number(state.reportData.items[item].totalRevenue || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            revNewCustomer: (Number(state.reportData.items[item].revNewCustomer || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            revReturnCustomer: (Number(state.reportData.items[item].revReturnCustomer || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            avgOrderValue: (Number(state.reportData.items[item].avgOrderValue || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            avgItemCount: Number(state.reportData.items[item].avgItemCount || 0).toFixed(2),
            totalRefund: (Number(state.reportData.items[item].totalRefund || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            totalDiscount: (Number(state.reportData.items[item].totalDiscount || 0) * Number(currencyRate?.rate || 1)).toFixed(2),
            orderCount: (state.reportData.items[item].orderCount || 0)
          }
        }
        if (payload.type === 'salesman') {
          return {
            ...state.reportData.items[item],
            date: item,
            totalPrice: (Number(state.reportData.items[item].totalPrice || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
          }
        }
        return { ...state.reportData.items[item], date: item, orderCount: state.reportData.items[item].orderCount || 0 }
      }).map(element => ({
        ...element
      }))
      if (payload.type !== 'products' && payload.type !== 'cashiers' && payload.type !== 'salesman') {
        state.json_data = dataResolved
      }
    }
    if (payload.type === 'orders') {
      state.orderReportData.items = payload.report
      fields = {
        [i18n.t('Order')]: 'orderName',
        [i18n.t('date')]: 'createdAt',
        [i18n.t('outlet_register')]: 'outletRegister',
        [i18n.t('Customer')]: 'customerName',
        [`${i18n.t('total')}${currentCurrencySymbol}`]: 'totalPrice',
        [`${i18n.t('tax')}${currentCurrencySymbol}`]: 'totalTax',
        [`${i18n.t('discount')}${currentCurrencySymbol}`]: 'totalDiscounts',
        [i18n.t('Order Status')]: 'orderStatus',
        [i18n.t('Fulfillment Status')]: 'fulfillmentStatus',
        [i18n.t('Payment Status')]: 'paymentStatus',
        [i18n.t('Payment Status Updated At')]: 'paymentStatusUpdatedAt',
        [i18n.t('Order Status Updated At')]: 'orderStatusUpdatedAt',
        [i18n.t('Source')]: 'source'
      }
      if (window.location.pathname === '/order-status') {
        fields = {
          ...fields,
          [i18n.t('Order note')]: 'orderNote',
          [i18n.t('Staff note')]: 'staffNote'
        }
      }
      if (window.location.pathname === '/payment-status' && payload.query.isIncludeReferenceNumber) {
        fields = { ...fields, [i18n.t('Payment info')]: 'paymentInfo' }
      }
      if (getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM) === platform.MAGENTO_2) {
        delete fields[i18n.t('Order Status Updated At')]
      }
      if (getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM) !== 'msi') {
        delete fields[i18n.t('Source')]
        delete fields[i18n.t('Order Status')]
      }

      const json_data = []
      state.orderReportData.paymentsCount = 0
      payload.report.forEach(element => {
        if (window.location.pathname === '/sales-order') {
          if ((element.paymentInfo || []).length > Number(state.orderReportData.paymentsCount || 0)) {
            state.orderReportData.paymentsCount = (element.paymentInfo || []).length
          }
        }
        json_data.push({
          ...element,
          totalTax: ((Number(element.totalTax || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          totalDiscounts: ((Number(element.totalDiscounts || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          totalPrice: ((Number(element.totalPrice || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          subtotalIncTax: ((Number(element.subtotalIncTax || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          subtotalExTax: ((Number(element.subtotalExTax || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          refundedTotalPrice: ((Number(element.refundedTotalPrice || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          totalTip: ((Number(element.totalTip || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          totalPaid: ((Number(element.totalPaid || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
          paymentInfo: (element.paymentInfo || []).map((e) => {
            let typePayment = ''
            switch (e.type) {
              case 'refund':
                typePayment = ' (Refunded)'
                break
              case 'change':
                typePayment = ' (Change)'
                break
              default:
                break
            }
            return {
              ...e,
              amount: ((Number(e.amount || 0) / Number(element.currencyExchangeRate || 1)) * Number(currencyRate?.rate || 1)),
              paymentName: `${e.paymentName}${typePayment}`
            }
          })
        })
      })
      if (window.location.pathname === '/sales-order') {
        delete fields[i18n.t('Order Status')]
        delete fields[i18n.t('Fulfillment Status')]
        delete fields[i18n.t('Payment Status')]
        delete fields[i18n.t('Payment Status Updated At')]
        delete fields[i18n.t('Order Status Updated At')]
        delete fields[i18n.t('Source')]
        delete fields[`${i18n.t('tax')}${currentCurrencySymbol}`]
        delete fields[`${i18n.t('discount')}${currentCurrencySymbol}`]
        delete fields[`${i18n.t('total')}${currentCurrencySymbol}`]
        fields = {
          ...fields,
          [`${i18n.t('Sub Total (Tax Included)')}${currentCurrencySymbol}`]: 'subtotalIncTax',
          [`${i18n.t('Sub Total (Tax Excluded)')}${currentCurrencySymbol}`]: 'subtotalExTax',
          [`${i18n.t('total')}${currentCurrencySymbol}`]: 'totalPrice',
          [`${i18n.t('tax')}${currentCurrencySymbol}`]: 'totalTax',
          [`${i18n.t('Refund')}${currentCurrencySymbol}`]: 'refundedTotalPrice',
          [`${i18n.t('discount')}${currentCurrencySymbol}`]: 'totalDiscounts'
        }
        delete fields[`${i18n.t('Tip')}${currentCurrencySymbol}`]
        delete fields[`${i18n.t('Charge')}${currentCurrencySymbol}`]
        if (payload.query.fieldsIncluded.includes('tipping')) {
          fields = {
            ...fields,
            [`${i18n.t('Tip')}${currentCurrencySymbol}`]: 'totalTip'
          }
        }
        if (payload.query.fieldsIncluded.includes('charge')) {
          fields = {
            ...fields,
            [`${i18n.t('Charge')}${currentCurrencySymbol}`]: 'totalPaid'
          }
        }
        for (let index = 1; index <= state.orderReportData.paymentsCount; index++) {
          fields = {
            ...fields,
            [i18n.t(`Payment method ${index} name`)]: `paymentMethodName${index}`,
            [`${i18n.t(`Payment method ${index} amount`)}${currentCurrencySymbol}`]: `paymentMethodAmount${index}`,
            [i18n.t(`Payment method ${index} ref#`)]: `paymentMethodRef${index}`
          }
        }
      }
      state.json_data_order = json_data
      state.json_fields_order = fields
    }
    if (payload.type === 'order-duration') {
      const avg = payload.report.reduce((prevValue, item) => prevValue + Number(item.avg_duration || 0), 0) / (payload.report.length || 1)
      payload.report = [
        {
          order_number: 'Average',
          avg_duration: (avg > 9 ? '' : '0') + avg.toFixed(2)
        },
        ...payload.report
      ]
      state.orderDurationReportData.items = payload.report
      fields = {
        [i18n.t('order_number')]: 'order_number',
        [i18n.t('date')]: 'created_at',
        [i18n.t('outlet_register')]: 'outletRegister',
        [i18n.t('customer_name')]: 'customerName',
        [i18n.t('Duration (day)')]: 'avg_duration'
      }

      const json_data = []
      payload.report.forEach(element => {
        json_data.push(element)
      })
      state.json_data_order = json_data
      state.json_fields_order = fields
    }
    if (payload.type === 'order-time-in-status') {
      const statusesReport = {}
      if ((state.query.states || []).length > 0) {
        state.query.states.forEach((state) => {
          statusesReport[i18n.t(state)] = state
        })
      }
      fields = {
        [i18n.t('order_number')]: 'order_number',
        [i18n.t('date')]: 'created_at',
        [i18n.t('outlet_register')]: 'outletRegister',
        [i18n.t('customer_name')]: 'customerName',
        ...statusesReport,
        [i18n.t('Total (day)')]: 'total'
      }

      const json_data = []
      payload.report.forEach(element => {
        json_data.push(element)
      })
      state.json_data_order = json_data
      state.json_fields_order = fields
      const timeInStatuses = {}

      if ((state.query.states || []).length > 0) {
        state.query.states.forEach((state) => {
          timeInStatuses[state] = (payload.report.reduce((prevValue, item) => prevValue + Number(item.timeInStatuses[state] || 0), 0) / (payload.report.length || 1)).toFixed(2)
        })
      }
      state.orderTimeInStatusReportData.items = [
        {
          order_number: 'Average',
          timeInStatuses,
          total: (payload.report.reduce((prevValue, item) => prevValue + Number(item.total || 0), 0) / (payload.report.length || 1)).toFixed(2)
        },
        ...payload.report
      ]
    }
    if (payload.type === 'cashiers' || payload.type === 'salesman') {
      const nameFields = {}
      Object.keys(cols).sort().forEach(col => {
        if (col === '') {
          col = ' '
        }
        nameFields[col.charAt(0).toUpperCase() + col.slice(1)] = col
        state.json_data.forEach((item, index) => {
          if (col === ' ') {
            state.json_data[index][col] = state.json_data[index]['']
          }
          state.json_data[index][col] = (parseFloat(state.json_data[index][col] || 0) * Number(currencyRate?.rate || 1)).toFixed(2)
        })
      })
      state.json_fields = {
        [i18n.t('Date')]: 'name',
        ...nameFields
      }
      totals = { name: 'Totals' }
      Object.keys(state.json_fields).forEach(item => {
        let total = 0
        Object.keys(list.items).forEach(items => {
          const keyItem = payload.type === 'cashiers' ? item.toLowerCase() : item
          totals = { ...totals, [keyItem]: (parseFloat(total += parseFloat(list.items[items][item === ' ' ? '' : keyItem] || 0)) * Number(currencyRate?.rate || 1)).toFixed(2) }
        })
        if (item !== 'Date') {
          state.json_fields[`${item}${currentCurrencySymbol}`] = state.json_fields[item]
          delete state.json_fields[item]
        }
      })
      state.json_data = state.json_data.filter(data => data.name !== 'Totals')
      state.json_data = [...state.json_data, totals]
    }
    if (window.location.pathname === '/number-of-orders') {
      totals = { date: 'Totals' }
      Object.keys(state.json_fields).forEach(item => {
        let total = 0
        Object.keys(list.items).forEach(items => {
          totals = { ...totals, orderCount: total += parseFloat(list.items[items].orderCount || 0) }
        })
      })
      state.json_data = state.json_data.filter(data => data.name !== 'Totals')
      state.json_data = [...state.json_data, totals]
    }
    /*    if (window.location.pathname === '/average-order-value') {
      totals = { date: 'Totals' }
      Object.keys(state.json_fields).forEach(item => {
        let total = 0
        Object.keys(list.items).forEach(items => {
          totals = { ...totals, avgOrderValue: total += parseFloat(list.items[items].avgOrderValue || 0) * Number(currencyRate?.rate || 1) }
        })
      })
      state.json_data = state.json_data.filter(data => data.name !== 'Totals')
      state.json_data = [...state.json_data, { ...totals, avgOrderValue: totals.avgOrderValue.toFixed(2) }]
    } */
    state.colsData = payload.type === 'payment-methods' || payload.type === 'outlet-revenue' || payload.type === 'categories' || payload.type === 'cashiers' || payload.type === 'salesman' ? Object.keys(cols).sort() : Object.keys(state.cols)
    if (reportType.usePaginations.includes(payload.type)) {
      state.count_items = payload.count_items
      state.query = payload.query
    }
    state.query.revenueType = false
  },
  SET_LIST_SALES_ORDER (state, payload) {
    state.salesOrderData = payload.salesOrderData
  },
  SET_CUSTOMIZE_DATA (state, payload) {
    state.customizeFields = payload
    var fields = {}
    const currencyRate = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
    const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    const currentCurrencySymbol = (currencyRate?.toCurrency || storeConfig?.currency || '') !== '' ? ` (${currencyRate?.toCurrency || storeConfig?.currency})` : ''
    for (var i = 0; i < state.customizeFields.length; i++) {
      const key = state.customizeFields[i].key || ''
      const labelHasCurrency = key === 'totalRevenue' || key === 'totalTax' || key === 'totalDiscount' || key === 'totalPrice' || key === 'cost' || key === 'grossProfit' ||
      key === 'netRevenue' || key === 'avgOrderValue' || key === 'revNewCustomer' || key === 'revReturnCustomer' || key === 'totalRefund'
      fields = { ...fields, [`${state.customizeFields[i].label}${labelHasCurrency ? currentCurrencySymbol : ''}`]: `${state.customizeFields[i].key}` }
    }
    if (!state.customizeFields.some((e) => e.key === 'date')) {
      fields = { [i18n.t('date')]: 'date', ...fields }
    }
    state.json_fields = { ...fields }
  },
  SET_TIPPING_DATA (state, payload) {
    const currencyRate = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
    const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    const currentCurrencySymbol = (currencyRate?.toCurrency || storeConfig?.currency || '') !== '' ? ` (${currencyRate?.toCurrency || storeConfig?.currency})` : ''
    let rate = currencyRate?.rate || 1
    if (payload.type === 'summary') {
      state.orderTippingSummary.items = [
        ...payload.report
      ]
    } else {
      state.orderTippingReportData.items = [
        ...payload.report
      ]
      state.json_data_order = payload.report.map((report) => {
        const element = { ...report }
        if (element.presentmentCurrency && element.currencyExchangeRate && element.presentmentCurrency === currencyRate?.toCurrency) {
          rate = element.currencyExchangeRate
        }
        element.orderTotalPrice = (Number(element.orderTotalPrice || 0) * Number(rate)).toFixed(6)
        element.amount = (Number(element.amount || 0) * Number(rate)).toFixed(6)
        return element
      })
    }
    var fields = {
      [i18n.t('date')]: 'createdAt',
      [i18n.t('Order')]: 'orderNumber',
      [i18n.t('outlet_register')]: 'outletRegister',
      [i18n.t('Customer')]: 'customerName',
      [`${i18n.t('Total Price')}${currentCurrencySymbol}`]: 'orderTotalPrice',
      [i18n.t('Sale person')]: 'salePerson',
      [`${i18n.t('Tipping amount')}${currentCurrencySymbol}`]: 'amount',
      [i18n.t('Tipping at')]: 'tippedCreatedAt'
    }
    state.json_fields_order = fields
    state.count_items = payload.count_items
    state.query = payload.query
  },
  SET_SALESPERSONS_DATA (state, payload) {
    state.salespersons = payload
  },
  CLEAR_GLOBAL_DATA (state, payload) {
    state.globalReport = {}
    state.mockGlobalReport = {}
  },
  PUBLISH_GLOBAL_REPORT (state, payload) {
    state.globalReport = state.mockGlobalReport
  },
  SET_GLOBAL_DATA (state, payload) {
    const startDate = moment(state.query.createdAtMin).toArray().slice(0, 3)
    const endDate = moment(state.query.createdAtMax).toArray().slice(0, 3)
    const list = {
      title: {},
      items: {}
    }
    if (payload.fillter_type === modeQuery.DATE) {
      const range = moment(endDate).diff(moment(startDate), 'days')
      const days = getColByDay(state.query.createdAtMin, range)
      Object.keys(days).forEach(key => {
        list.items[formatDay(key) || ''] = Object.assign({}, list.items[formatDay(key) || ''] || {})
      })
      
      const sortedData = payload.report.sort((a, b) => new Date(a.day) - new Date(b.day))
      sortedData.forEach(item => {
        list.items[formatDay(item.day) || ''] = Object.assign({}, list.items[formatDay(item.day) || ''] || {})
        list.items[formatDay(item.day) || ''] = Object.assign({}, item)
        list.title[formatDay(item.day) || ''] = formatDay(item.day)
      })
    }
    if (payload.fillter_type === modeQuery.MONTH) {
      const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.month) - parseInt(b.month))
      sortedData.forEach(item => {
        list.items[item.month + '/' + item.year || ''] = Object.assign({}, list.items[item.month + '/' + item.year || ''] || {})
        list.items[item.month + '/' + item.year || ''] = Object.assign({}, item)
        list.title[formatDay(item.day) || ''] = formatDay(item.day)
      })
    }
    if (payload.fillter_type === modeQuery.YEAR) {
      const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year))
      sortedData.forEach(item => {
        list.items[item.year || ''] = Object.assign({}, list.items[item.year || ''] || {})
        list.items[formatyear(item.year) || ''] = Object.assign({}, item)
        list.title[formatDay(item.day) || ''] = formatDay(item.day)
      })
    }
    if (payload.fillter_type === modeQuery.WEEK) {
      const sortedData = payload.report.sort((a, b) => parseInt(a.year) - parseInt(b.year) || parseInt(a.week) - parseInt(b.week))
      sortedData.forEach(item => {
        list.items['Week ' + item.week || ''] = Object.assign({}, list.items['Week ' + item.week || ''] || {})
        list.items['Week ' + item.week || ''] = Object.assign({}, item)
        list.title[formatDay(item.day) || ''] = formatDay(item.day)
      })
    }
    if (payload.storeId && (payload.outletId || !!payload.isGlobalStores)) {
      state.mockGlobalReport = {
        ...(state.mockGlobalReport || {}),
        [payload.storeId]: {
          ...((state.mockGlobalReport || {})[payload.storeId] || {}),
          ...(payload.outletId && !payload.isGlobalStores ? { [payload.outletId]: list } : { [payload.storeId]: list })
        }
      }
    }
  },
  SET_DATA_PRODUCT_SOLD_CHART (state, payload) {
    state.productSoldChart = payload.data
  },
  SET_LOADING_REPORT (state, loading) {
    state.loading = loading
  },
  SET_LOADING_PRODUCT_SOLD (state, loading) {
    state.isLoadingProductSoldChart = loading
  },
  SET_QUERY_REPORT (state, payload) {
    state.type = payload.type
    state.query = payload.query
    state.currentPath = payload.currentPath
  },
  SET_COLS_REPORT (state, cols) {
    state.cols = cols
  },
  SET_LIST_REPORT_NO_DATA (state) {
    state.reportData = {}
    state.mockGlobalReport = {}
    state.globalReport = {}
    state.sellReportData = {
      items: [],
      paymentsCount: []
    }
    state.orderTimeInStatusReportData = {
      items: [],
      title: {}
    }
    state.orderTippingReportData = {
      items: [],
      title: {}
    }
    state.salespersons = []
    state.productReportData = {}
    state.paymentReportData = {}
    state.orderReportData = {}
    state.colsData = []
  },
  SET_EXCEL_DATA_SELL_REPORT (state, payload) {
    state.json_data_sell_report = payload.json_data
  },
  SET_EXPORTING (state, payload) {
    state.isExporting = payload
  },
  SET_CHANGE_STORE (state, payload) {
    state.isChangeStore = payload
  }
}
